import { Item } from '@components/select';
import { UserGetResponse } from '@lio/api-types';

const getInitialUserRole = (user?: UserGetResponse): string | string[] => {
  if (user) {
    if (user.lioUsers.length > 0) {
      return user.lioUsers.map((el) => el.role);
    }
    if (user.brokerageUsers.length > 0) {
      return user.brokerageUsers[0].role;
    }
  }
  return [];
};

const getInitialBrokerage = (user?: UserGetResponse, brokerages?: Item[]): Item | undefined => {
  if (user && brokerages) {
    if (user.brokerageUsers.length > 0) {
      const initialBrokerage = brokerages.find((el) => el.value === user.brokerageUsers?.[0]?.brokerageId);
      if (initialBrokerage) {
        return { value: initialBrokerage.value, label: initialBrokerage.label };
      }
    }
  }
  return undefined;
};

export { getInitialUserRole, getInitialBrokerage };
